import { render, staticRenderFns } from "./eg_colored_dot_box.vue?vue&type=template&id=76c9cd0a&scoped=true&"
import script from "./eg_colored_dot_box.vue?vue&type=script&lang=js&"
export * from "./eg_colored_dot_box.vue?vue&type=script&lang=js&"
import style0 from "./eg_colored_dot_box.vue?vue&type=style&index=0&id=76c9cd0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c9cd0a",
  null
  
)

export default component.exports